// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1b-2";
export var blackBorderOnHover = "_1b-7";
export var cell = "_1b-6";
export var cellContainer = "_1b-3";
export var checked = "_1b-8";
export var disabled = "_1b-5";
export var featuredIconCellContainer = "_1b-9";
export var featuredIconTextContainer = "_1b-b";
export var featuredIconWrapper = "_1b-a";
export var noBorder = "_1b-c";
export var orangeSelectedRow = "_3v-3";
export var overflowableText = "_1b-0";
export var overflowableTextContainer = "_1b-1";
export var row = "_1d-0";
export var rowCheckboxCell = "_1b-4";
export var selectableTable = "_3v-2";